/* eslint-disable prefer-destructuring */
import React, { Component } from 'react';

import { Container, Grid, Typography, Button, styled, Stack } from '@mui/material';
import { withSnackbar } from 'notistack';
import { withTranslation } from 'react-i18next';
import ReactPlaceholder from 'react-placeholder/lib';
import { connect } from 'react-redux';
import { Breadcrumbs, Table } from 'wae_rwlb_reactlibrary';
import XLSX from 'xlsx';

import { addMultipleItemToCart, loadUploadExcelData } from '../../actions';
import { breadcrumbNameMap } from '../../helpers/config';
import CreateInquiryPlaceholder from './CreateInquiryPlaceholder';

const columnsConfig = t => [
  {
    field: 'col1',
    headerName: t('uploadScreenTranslations:MATERIAL'),
    key: 'Material',
    width: 150,
    flex: 1,
  },
  {
    field: 'col2',
    headerName: t('uploadScreenTranslations:QTY'),
    key: 'ConditionQuantity',
    width: 150,
    flex: 1,
  },
  {
    field: 'col3',
    headerName: t('uploadScreenTranslations:SUBTOTAL'),
    key: 'subTotal',
    width: 150,
    flex: 1,
  },
  {
    field: 'col4',
    headerName: t('uploadScreenTranslations:STATUS'),
    key: 'AvailableStock',
    width: 150,
    flex: 1,
    renderCell: params => (
      <Typography variant="subtitle1" component="h2" color={params.value ? 'green' : 'error'}>
        {params.value ? t('uploadScreenTranslations:AVAILABLE') : 'Not Available'}
        {/* // TODO: Move to i18n  */}
      </Typography>
    ),
  },
];

const Input = styled('input')({
  display: 'none',
});
const errorMsgText = 'uploadScreenTranslations:MSG2';
class CreateInquiry extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedRows: [],
      isError: false,
      page: 0,
      rowsPerPage: 20,
    };
  }

  handleAddToCart = () => {
    const { t, upload } = this.props;
    const { uploadData } = upload;
    try {
      const { selectedRows } = this.state;

      const list = [];
      if (uploadData.length > 0) {
        uploadData.forEach((l, index) => {
          if (selectedRows.some(s => s === index)) {
            const {
              Material,
              MaterialName,
              MaterialGrossWeight,
              ConditionQuantity,
              SalesPrice,
              SalesPriceUnit,
              StockQuantityUOM,
              StockQuantity,
            } = l;

            if (SalesPrice > 0) {
              const res = {
                Material,
                qty: parseInt(ConditionQuantity, 10),
                MaterialName,
                Price: SalesPrice,
                Currency: SalesPriceUnit,
                ConditionQuantity,
                MaterialGrossWeight,
                available: true,
                StockQuantityUOM,
                StockQuantity,
              };
              list.push(res);

              this.props.enqueueSnackbar(t('uploadScreenTranslations:MSG1'), {
                variant: 'success',
              });
            } else {
              this.props.enqueueSnackbar(t('uploadScreenTranslations:MSG2'), {
                variant: 'error',
              });
            }
          }
        });
        this.props.addMultipleItemToCart(list);
        this.setState({ selectedRows: [] });
      }
    } catch (err) {
      this.props.enqueueSnackbar(t(errorMsgText), { variant: 'error' });
      console.log(err);
    }
  };

  fileReader = async oEvent => {
    const { t } = this.props;

    try {
      this.setState({ selectedRows: [] });
      const oFile = oEvent.target.files[0];
      const fileType = oFile.name.split('.');
      if (fileType[1] === 'xlsx') {
        const reader = new FileReader();
        // const itemsData = [];
        reader.onload = e => {
          try {
            let data = e.target.result;
            data = new Uint8Array(data);
            const workbook = XLSX.read(data, { type: 'array' });

            const result = {};
            result.Sheet1 = XLSX.utils.sheet_to_json(workbook.Sheets.Sheet1, {
              header: 1,
            });

            const sheet1 = result.Sheet1;
            const c1 = sheet1[0][0];
            const c2 = sheet1[0][1];
            // const c3 = sheet1[0][2];
            // const c4 = sheet1[0][3];
            // const c5 = sheet1[0][4];

            sheet1.shift();
            let obj = {};
            const excelData = [];
            sheet1.map(s => {
              obj[c1] = s[0];
              obj[c2] = s[1];
              // obj[c3] = s[2];
              // obj[c4] = s[3];
              // obj[c5] = s[4];
              excelData.push(obj);
              obj = {};
              return s;
            });

            let filterArr = [];
            let filterStr = '';
            filterArr = excelData.map(l => `Material eq '${l.Material}'`);
            filterStr = filterArr.join(' or ');
            this.props.loadUploadExcelData(
              this.props.enqueueSnackbar,
              filterStr,
              excelData,
              oFile.name
            );
          } catch (err) {
            this.props.enqueueSnackbar(t(errorMsgText), {
              variant: 'error',
            });
            console.log(err);
            this.setState({ isError: true });
          }
        };
        reader.readAsArrayBuffer(oFile);
      } else {
        this.props.enqueueSnackbar(t('uploadScreenTranslations:MSG3'), {
          variant: 'error',
        });
      }
    } catch (err) {
      this.props.enqueueSnackbar(t(errorMsgText), {
        variant: 'error',
      });
      console.log(err);
    }
  };

  onSelectionModelChange = s => {
    this.setState({ selectedRows: s });
  };

  onChangeBrowseInput = e => {
    this.fileReader(e);
    e.target.value = '';
  };

  saveFilterData = fData => {
    this.setState({ filteredData: fData });
  };

  s2ab = s => {
    const buf = new ArrayBuffer(s.length);
    const view = new Uint8Array(buf);
    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < s.length; i++) {
      // eslint-disable-next-line no-bitwise
      view[i] = s.charCodeAt(i) & 0xff;
    }
    return buf;
  };

  handleDownloadSampleFormat = () => {
    const formattedData = [{ Material: '', ConditionQuantity: '' }];

    const workbook = XLSX.utils.book_new();
    const worksheet = XLSX.utils.json_to_sheet(formattedData);
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Formatted Data');
    const excelBlob = new Blob(
      [this.s2ab(XLSX.write(workbook, { bookType: 'xlsx', type: 'binary' }))],
      {
        type: 'application/octet-stream',
      }
    );

    const downloadLink = document.createElement('a');
    downloadLink.href = URL.createObjectURL(excelBlob);
    downloadLink.download = 'Sampleformatteddata.xlsx';

    downloadLink.click();
  };

  handleDownload = () => {
    const { upload } = this.props;
    const { uploadData } = upload;

    if (uploadData.length > 0) {
      const formattedData = [];

      uploadData.forEach(item => {
        const formattedItem = {
          Material: item.Material,
          ConditionQuantity: item.ConditionQuantity,
          Subtotal: item.subTotal,
          Status: item.AvailableStock ? 'Available' : 'Not Available',
        };
        formattedData.push(formattedItem);
      });

      const wb = XLSX.utils.book_new();
      const ws = XLSX.utils.json_to_sheet(formattedData);
      XLSX.utils.book_append_sheet(wb, ws, 'Uploded');
      const excelBlob = new Blob(
        [this.s2ab(XLSX.write(wb, { bookType: 'xlsx', type: 'binary' }))],
        {
          type: 'application/octet-stream',
        }
      );

      const downloadLink = document.createElement('a');
      downloadLink.href = URL.createObjectURL(excelBlob);
      downloadLink.download = 'uploadeddata.xlsx';

      downloadLink.click();
    }
  };

  render() {
    const { selectedRows, isError, page, rowsPerPage, filteredData } = this.state;
    const { t, upload } = this.props;
    const { uploadData, isLoading } = upload;
    const isErrorText = !isError
      ? t('uploadScreenTranslations:MSG4')
      : t('uploadScreenTranslations:MSG5');
    return (
      <Container>
        <Breadcrumbs {...this.props} breadcrumbNameMap={breadcrumbNameMap(t)} />
        <Grid container direction="row" justifyContent="center" sx={{ marginY: 6 }}>
          <Grid item xs={12} sm={12} md={9}>
            <Grid
              item
              container
              direction="row"
              justifyContent="space-between"
              style={{ marginBottom: 10 }}
            >
              <Grid
                item
                container
                direction="row"
                justifyContent="flex-start"
                xs={6}
                alignItems="center"
              >
                <Button
                  variant="contained"
                  color="primary"
                  disabled={uploadData.length === 0 || selectedRows.length === 0}
                  onClick={this.handleAddToCart}
                  sx={{
                    fontSize: { xs: 10, sm: 12, md: 14 },
                  }}
                >
                  {t('uploadScreenTranslations:ADD_TO_CART')}
                </Button>
              </Grid>
              <Grid
                item
                container
                direction="row"
                justifyContent="flex-end"
                xs={6}
                alignItems="center"
              >
                <Stack direction="row" spacing={2}>
                  <Button
                    variant="contained"
                    color="primary"
                    component="span"
                    onClick={this.handleDownloadSampleFormat}
                    sx={{
                      fontSize: { xs: 10, sm: 12, md: 14 },
                    }}
                  >
                    {t('uploadScreenTranslations:DOWNLOAD_SAMPLE_FORMAT')}
                  </Button>
                  <Button
                    variant="contained"
                    color="primary"
                    component="span"
                    onClick={this.handleDownload}
                    disabled={uploadData.length === 0}
                    sx={{
                      fontSize: { xs: 10, sm: 12, md: 14 },
                    }}
                  >
                    {t('uploadScreenTranslations:DOWNLOAD')}
                  </Button>
                  <label htmlFor="contained-button-file">
                    <Input
                      accept="xlxs/*"
                      id="contained-button-file"
                      multiple
                      type="file"
                      onChange={this.onChangeBrowseInput}
                    />
                    <Button
                      variant="contained"
                      color="primary"
                      component="span"
                      sx={{
                        fontSize: { xs: 10, sm: 12, md: 14 },
                      }}
                    >
                      {t('uploadScreenTranslations:BROWSE')}
                    </Button>
                  </label>
                </Stack>
              </Grid>
            </Grid>
            <ReactPlaceholder
              showLoadingAnimation
              ready={!isLoading}
              customPlaceholder={<CreateInquiryPlaceholder />}
            >
              <>
                {uploadData.length > 0 ? (
                  <Table
                    checkboxSelection
                    columnsConfig={columnsConfig(t)}
                    data={uploadData}
                    isRowSelectable={params => params.row.col4 === true}
                    onSelectionModelChange={this.onSelectionModelChange}
                    selectionModel={selectedRows}
                    rowsPerPage={rowsPerPage}
                    listCount={uploadData.length}
                    page={page}
                    saveFilterData={fData => this.saveFilterData(fData)}
                    filteredData={filteredData}
                    t={this.props.t}
                  />
                ) : (
                  <Stack justifyContent="center" m={6}>
                    <Typography variant="h5" alignSelf="center">
                      {isErrorText}
                    </Typography>
                  </Stack>
                )}
              </>
            </ReactPlaceholder>
          </Grid>
        </Grid>
      </Container>
    );
  }
}

const mapStateToProps = state => {
  return { cart: state.cart, product: state.product, upload: state.upload };
};
const cCreateInquiry = connect(mapStateToProps, {
  addMultipleItemToCart,
  loadUploadExcelData,
})(CreateInquiry);
const tCreateInquiry = withTranslation(['uploadScreenTranslations'])(cCreateInquiry);
const sCreateInquiry = withSnackbar(tCreateInquiry);
export { sCreateInquiry as CreateInquiry };
